/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Pain_Area_ThoracicInputs */

const en_us2_profile_editors_pain_area_thoracic = /** @type {(inputs: Profile_Editors_Pain_Area_ThoracicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upper back`)
};

const pt_br2_profile_editors_pain_area_thoracic = /** @type {(inputs: Profile_Editors_Pain_Area_ThoracicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Costas (parte alta)`)
};

const es_419_profile_editors_pain_area_thoracic = /** @type {(inputs: Profile_Editors_Pain_Area_ThoracicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espalda alta`)
};

const pt_pt2_profile_editors_pain_area_thoracic = /** @type {(inputs: Profile_Editors_Pain_Area_ThoracicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Costas (parte superior)`)
};

const fr_fr2_profile_editors_pain_area_thoracic = /** @type {(inputs: Profile_Editors_Pain_Area_ThoracicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haut du dos`)
};

const de_de2_profile_editors_pain_area_thoracic = /** @type {(inputs: Profile_Editors_Pain_Area_ThoracicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oberer Rücken`)
};

const it_it2_profile_editors_pain_area_thoracic = /** @type {(inputs: Profile_Editors_Pain_Area_ThoracicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parte alta della schiena`)
};

/**
* | output |
* | --- |
* | "Upper back" |
*
* @param {Profile_Editors_Pain_Area_ThoracicInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_pain_area_thoracic = /** @type {((inputs?: Profile_Editors_Pain_Area_ThoracicInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Pain_Area_ThoracicInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_pain_area_thoracic(inputs)
	if (locale === "es-419") return es_419_profile_editors_pain_area_thoracic(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_pain_area_thoracic(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_pain_area_thoracic(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_pain_area_thoracic(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_pain_area_thoracic(inputs)
	return en_us2_profile_editors_pain_area_thoracic(inputs)
});
export { profile_editors_pain_area_thoracic as "profile-editors.pain_area_thoracic" }